
import LolePicture from '~/components/picture/lole-picture'

export default {
  components: {
    LolePicture,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    imageIndex: {
      type: [Number],
      default: null,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    images() {
      return (
        this.product.medias.filter((m) => {
          return m.type === 'image'
        }) || []
      )
    },
    isFiltered() {
      const images = this.product.medias.filter((m) => {
        return m.type === 'image'
      })
      return images.length !== this.product.medias.length
    },
  },
  created() {
    // eslint-disable-next-line nuxt/no-globals-in-created
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) {
        this.$emit('close')
      }
    })
  },
  destroyed() {
    document.removeEventListener('keyup')
  },
  mounted() {
    this.loading = true
    const index = this.isFiltered ? this.imageIndex - 1 : this.imageIndex
    setTimeout(() => {
      const viewHeight = this.$refs['gallery-img-1'][0].offsetHeight
      const offsetMultiplier = window.innerWidth < 767 ? 2 : 1
      const indexYOffset = viewHeight * index - viewHeight * offsetMultiplier
      this.$el.scrollTop = indexYOffset
      this.loading = false
    }, 60)
  },
}
